import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { FormControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';

import { UsersResource } from '../../../services/resources/users.resource';

@Component({
    selector: 'sl-users-dialog-form',
    templateUrl: './users-dialog-form.component.html',
    styleUrls: ['./users-dialog-form.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class UsersDialogFormComponent implements OnInit {
    formGroup: UntypedFormGroup;

    readonly usersResource = inject(UsersResource);

    private readonly formBuilder = inject(UntypedFormBuilder);

    ngOnInit(): void {
        this.setupForm();
    }

    private setupForm(): void {
        const controlValue = undefined;
        this.formGroup = this.formBuilder.group({
            windowsUser: new FormControl(controlValue, undefined),
            username: new FormControl(controlValue, undefined),
            firstName: new FormControl(controlValue, undefined),
            lastName: new FormControl(controlValue, undefined),
            employeeNumber: new FormControl(controlValue, undefined),
            function: new FormControl(controlValue, undefined),
            roleId: new FormControl(controlValue, Validators.required),
            phone: new FormControl(controlValue, undefined),
            email: new FormControl(controlValue, undefined),
            languageId: new FormControl(controlValue, undefined),
            getsNotified: new FormControl(controlValue, undefined),
            approvalRight: new FormControl(controlValue, undefined),
            mobilePhoneNumber: new FormControl(controlValue, undefined)
        });
    }
}
